import { createSlice } from "@reduxjs/toolkit";
const initialState = {
   jobId:""
};
export const userJobIdSlice = createSlice({
    name: "jobId",
    initialState,
    reducers: {
        userJobId: (state,action) => {
            state.jobId=action.payload
        },
    },
});
export const {
    userJobId
} = userJobIdSlice.actions;
export default userJobIdSlice.reducer;
